/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';
import { LogCategory } from '../../../logger';
import { ExpandValue, TeamTagResult } from '../../../service/gen';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getTeamTag } from '../../../utilities/TeamTagPeoplePickerUtils';
import { TeamTagCardView } from './TeamTagCardView';

export interface ITeamTagCardProps {
    teamTagId: string;
    teamId: string;
}

export const TeamTagCardContainer: React.FC<ITeamTagCardProps> = (props: ITeamTagCardProps): JSX.Element | null => {
    const { teamId, teamTagId } = props;
    const [tagCardInfo, setTagCardInfo] = React.useState<TeamTagResult | undefined>();
    const [error, setError] = React.useState('');
    React.useEffect((): void => {
        getTeamTag(teamId, teamTagId, ExpandValue.MembersWithPhoto)
            .then((tagInfo: TeamTagResult | undefined): void => {
                setTagCardInfo(tagInfo);
            })
            .catch((e: Error): void => {
                const host = getAppHost();
                const logger = host.getLogger();
                const loc = host.getLocale();
                setError(loc.strings.error_default);
                logger.logTraceError(LogCategory.PeoplePicker, `fetch teamtag data error: ${e}`);
            });
    }, [teamId, teamTagId]);

    return error ? null : <TeamTagCardView tagCardData={tagCardInfo} />;
};
